var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 263,
    viewBox: "0 0 263 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263 131.5C263 204.125 204.125 263 131.5 263C58.8746 263 0 204.125 0 131.5C0 58.8746 58.8746 0 131.5 0C204.125 0 263 58.8746 263 131.5ZM21.04 131.5C21.04 192.505 70.4946 241.96 131.5 241.96C192.505 241.96 241.96 192.505 241.96 131.5C241.96 70.4946 192.505 21.04 131.5 21.04C70.4946 21.04 21.04 70.4946 21.04 131.5Z",
    fill: "#36807E",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleCircle);
export default __webpack_public_path__ + "static/media/middleCircle.d14fc826e1f791eda482cb132e47bbc6.svg";
export { ForwardRef as ReactComponent };